<template>
  <div class="flex flex-col items-center justify-center p-32">
    <RevIllustration
      alt=""
      :height="220"
      imageClassNames="m-72"
      sizes="40px"
      src="/img/customer-care/not-found.svg"
      :width="240"
    />
    <div class="flex flex-col items-center space-y-8">
      <h2 class="body-1-bold">{{ i18n(translations.title) }}</h2>

      <p v-if="description" class="text-center">{{ description }}</p>
      <p v-else>{{ i18n(translations.defaultDescription) }}</p>

      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'

import translations from './NoResultFoundBlock.translations'

const i18n = useI18n()

defineProps<{
  description?: string
}>()
</script>
